/**
 * Campaign spotlight countdown (sections/alc-campaign-spotlight.liquid).
 *
 * <alc-cs-countdown data-end="YYYY-MM-DD">: counts down to 23:59:59 of that day,
 * Bucharest time (the store's time zone). The server renders a first value; once the
 * campaign has ended the clock hides itself rather than announcing it on the banner.
 */
(() => {
  if (customElements.get('alc-cs-countdown')) return;

  const pad = (n) => String(n).padStart(2, '0');

  // UTC offset of Europe/Bucharest on a given day ("+03:00" in summer, "+02:00" in winter).
  function bucharestOffset(date) {
    try {
      const part = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Bucharest', timeZoneName: 'longOffset' })
        .formatToParts(date)
        .find((p) => p.type === 'timeZoneName');
      const m = part && /GMT([+-]\d{2}:\d{2})/.exec(part.value);
      if (m) return m[1];
    } catch (e) {}
    return '+02:00';
  }

  function endOf(day) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return null;
    return new Date(`${day}T23:59:59${bucharestOffset(new Date(`${day}T12:00:00Z`))}`);
  }

  class AlcCsCountdown extends HTMLElement {
    connectedCallback() {
      this.end = endOf(this.dataset.end || '');
      if (!this.end) {
        this.hidden = true;
        return;
      }
      this.el = {
        du: this.querySelector('[data-d-unit]'),
        d: this.querySelector('[data-d]'),
        dl: this.querySelector('[data-d-label]'),
        h: this.querySelector('[data-h]'),
        m: this.querySelector('[data-m]'),
        s: this.querySelector('[data-s]'),
      };
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      let left = Math.floor((this.end - Date.now()) / 1000);
      if (left <= 0) {
        clearInterval(this.timer);
        this.hidden = true;
        return;
      }
      const d = Math.floor(left / 86400);
      left -= d * 86400;
      const h = Math.floor(left / 3600);
      left -= h * 3600;
      const m = Math.floor(left / 60);
      // The last day drops the "0 days" chip.
      this.el.du.hidden = d === 0;
      this.el.d.textContent = d;
      this.el.dl.textContent = d === 1 ? this.dataset.day : this.dataset.days;
      this.el.h.textContent = pad(h);
      this.el.m.textContent = pad(m);
      this.el.s.textContent = pad(left - m * 60);
    }
  }

  customElements.define('alc-cs-countdown', AlcCsCountdown);
})();
